import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type TimeBadgeConfig } from './time-badge.types';

@Component({
  selector: 'app-time-badge',
  templateUrl: './time-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class TimeBadge {
  readonly config = input.required<TimeBadgeConfig>();

  protected readonly timeTextConfig = computed(() => ({
    text: this.config().time,
    size: 'base' as const,
    fontWeight: 'semibold' as const,
    cssVarPrefix: 'timebadge',
  }));

  protected readonly labelTextConfig = computed(() => ({
    text: this.config().label,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    cssVarPrefix: 'timebadge',
  }));
}
